import { render, staticRenderFns } from "./BrandAutocomplete.vue?vue&type=template&id=3261269e"
import script from "./BrandAutocomplete.ts?vue&type=script&lang=ts&external"
export * from "./BrandAutocomplete.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports